"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_router_dom_1 = require("react-router-dom");
const common_styled_components_1 = require("../../common-styled-components");
const useFetch_1 = __importDefault(require("../../../hooks/useFetch"));
const compliance_pool_types_1 = require("../compliance-pool-types");
const apiUtils_1 = require("../../../util/apiUtils");
const ComplianceKPI_1 = __importDefault(require("../common/ComplianceKPI"));
const compliance_1 = require("../../../util/compliance/compliance");
const useMetadata_1 = require("../../../hooks/useMetadata");
const util_1 = require("../util");
const theme_1 = require("../../../theme");
const LineChart_1 = __importDefault(require("../LineChart"));
const react_1 = require("react");
const TransactionTable_1 = require("../common/tables/TransactionTable");
const VoyageTable_1 = require("../common/tables/VoyageTable");
const routes_1 = require("../../../util/routes");
const isNonEmptyObject_1 = require("../../../util/isNonEmptyObject");
const NavigationContext_1 = require("../../../contexts/NavigationContext");
const TransactionSummary_1 = require("../common/TransactionSummary");
const YearContext_1 = require("../../../contexts/YearContext");
const lodash_1 = require("lodash");
const VoyageBarChart_1 = __importDefault(require("../admin/VoyageBarChart"));
exports.default = () => {
    const { selectedYear } = (0, YearContext_1.useYear)();
    const { shipId } = (0, react_router_dom_1.useParams)();
    const [metadata] = (0, useMetadata_1.useMetadata)();
    const [ship, _setShipUrl, _setShipBody] = (0, useFetch_1.default)("ship/ship.json", undefined, true);
    const [voyages, _setVoyagesUrl, _setVoyagesBody] = (0, useFetch_1.default)("voyage/voyages.json", undefined, true);
    const [usageAnalysis, _setAnalysisUrl, _setAnalysisBody, refreshAnalysis] = (0, useFetch_1.default)("ship/ship_fuel_usage.json", undefined, true);
    (0, react_1.useEffect)(() => {
        _setShipBody(JSON.stringify({
            ship_id: Number(shipId),
            year: selectedYear,
        }));
        _setVoyagesBody(JSON.stringify({
            ship_id: Number(shipId),
            year: selectedYear,
        }));
        _setAnalysisBody(JSON.stringify({ ship_id: Number(shipId), year: selectedYear }));
    }, [selectedYear, shipId]);
    // const [bioDiesel, _setBioDieselUrl, setBioDieselBody] = useFetch<Calculation>(
    //   "calculator/cost-comparison",
    //   undefined,
    //   true
    // );
    const showNonAdjustedData = true;
    // useEffect(() => {
    //   if (
    //     usageData &&
    //     usageData.ship.forecast.total.adjusted_emission_balance_ton < 0 &&
    //     metadata &&
    //     bioDiesel.status === LoaderStatus.Idle
    //   ) {
    //     const bodyBasis: Partial<FleetCalculatorParams> = {
    //       fleet_size: 1,
    //       year: selectedYear,
    //       fuels: usageData.ship.forecast.forecast_fuels.map((fuelAmount) => {
    //         return {
    //           engine_type: fuelAmount.engine_type,
    //           fuel_type: fuelAmount.fuel,
    //           foc: fuelAmount.amount,
    //           fuel_price:
    //             mockFuelPrices[fuelAmount.fuel] ??
    //             metadata.fuels?.[fuelAmount.fuel]?.price ??
    //             0,
    //         };
    //       }),
    //     };
    //     const iceFuels = [24];
    //     const bodyB30 = {
    //       ...bodyBasis,
    //       comparison_fuels: iceFuels.map((f) => ({
    //         engine_change_cost: 0,
    //         engine_type: 1,
    //         fuel_price: mockFuelPrices[f] ?? metadata.fuels[f]?.price ?? 0,
    //         fuel_type: f,
    //         engine_efficiency: metadata["efficiency-fuel-engine"][f][1],
    //         intensity: metadata["intensity-fuel-engine"][f][1],
    //       })),
    //     };
    //     setBioDieselBody(JSON.stringify(bodyB30));
    //   }
    // }, [usageAnalysis.status, metadata]);
    if (ship.status !== apiUtils_1.LoaderStatus.Success ||
        voyages.status !== apiUtils_1.LoaderStatus.Success ||
        usageAnalysis.status !== apiUtils_1.LoaderStatus.Success ||
        !metadata) {
        return (0, jsx_runtime_1.jsx)(common_styled_components_1.PageContent, { children: "Loading\u2026" });
    }
    const shipData = ship.data;
    const voyageData = voyages.data;
    const usageData = usageAnalysis.data;
    if (!shipData) {
        return (0, jsx_runtime_1.jsx)(common_styled_components_1.PageContent, { children: "Ship not found!" });
    }
    const analysis = usageData.ship.analysis;
    const transactions = usageData.ship.transactions;
    const poiData = transactions.from
        .map((t) => (0, util_1.getTransactionPOI)(t, "from"))
        .concat(transactions.to.map((t) => (0, util_1.getTransactionPOI)(t, "to")));
    // log([
    //   {
    //     label: "Metadata",
    //     content: metadata,
    //   },
    //   {
    //     label: "Usage analysis",
    //     content: usageData,
    //   },
    //   {
    //     label: "BioDiesel calculation",
    //     content:
    //       bioDiesel.status === LoaderStatus.Success ? bioDiesel.data : "loading",
    //   },
    // ]);
    const forecastsAvailable = (0, compliance_pool_types_1.isForecast)(usageData?.ship.forecast) &&
        usageData?.ship.forecast.forecast !== undefined &&
        usageData?.ship.forecast.total !== undefined &&
        !(0, lodash_1.isEmpty)(usageData.ship.forecast.forecast);
    const forecastFuels = forecastsAvailable
        ? (0, util_1.combineFuels)(usageData.ship.forecast.forecast_fuels_total)
        : undefined;
    const forecastDate = forecastsAvailable
        ? new Date(usageData.ship.forecast.end)
        : undefined;
    return ((0, jsx_runtime_1.jsxs)(common_styled_components_1.PageContent, { align: "left", children: [(0, jsx_runtime_1.jsxs)(common_styled_components_1.ContentGrid, { children: [(0, jsx_runtime_1.jsxs)(common_styled_components_1.GridCard, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.SectionTitle, { children: shipData.name }), (0, jsx_runtime_1.jsxs)(common_styled_components_1.PTight, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.Bold, { children: "Vessel name: " }), shipData.name] }), (0, jsx_runtime_1.jsxs)(common_styled_components_1.PTight, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.Bold, { children: "IMO: " }), shipData.imo] }), (0, jsx_runtime_1.jsxs)(common_styled_components_1.PTight, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.Bold, { children: "Pool: " }), (0, jsx_runtime_1.jsx)(NavigationContext_1.LinkWithHistory, { to: `${routes_1.routeNames.complianceRoot}/${routes_1.routeNames.pool}/${shipData.pool[selectedYear]?.pool_id}`, children: shipData.pool[selectedYear]?.pool_name ?? "N/A" })] })] }), (0, jsx_runtime_1.jsx)(common_styled_components_1.GridCard, { children: (0, jsx_runtime_1.jsx)(ComplianceKPI_1.default, { compliance: (0, compliance_1.getCompliance)(analysis.intensities.total.adjusted_emission_balance_ton), title: "Carbon intensity", unit: "gCO\u2082e/MJ", value: analysis.intensities.total.adjusted_intensity_gCO2e_per_MJ }) }), (0, jsx_runtime_1.jsx)(common_styled_components_1.GridCard, { children: (0, jsx_runtime_1.jsx)(ComplianceKPI_1.default, { compliance: (0, compliance_1.getCompliance)(analysis.intensities.total.adjusted_emission_balance_ton), title: "Carbon unit balance", unit: analysis.intensities.total.adjusted_emission_balance_ton < 0
                                ? "tCO₂e deficit"
                                : "tCO₂e to spare", value: (0, util_1.scaleEmissions)(analysis.intensities.total.adjusted_emission_balance_ton) }) })] }), (0, jsx_runtime_1.jsxs)(common_styled_components_1.ContentGrid, { "$cols": 2, children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.GridCard, { children: (0, jsx_runtime_1.jsx)(LineChart_1.default, { title: "Ship carbon intensity", unit: "gCO\u2082e/MJ", data: (showNonAdjustedData && poiData.length
                                ? [
                                    {
                                        name: "Intensity without transactions",
                                        color: theme_1.theme.colors.grey(2),
                                        data: analysis.intensities.cumulative?.map((d) => ({
                                            date: new Date(d.date),
                                            value: d.intensity.intensity_gCO2e_per_MJ,
                                        })) ?? [],
                                        prediction: forecastsAvailable && forecastDate
                                            ? {
                                                date: forecastDate,
                                                value: usageData.ship.forecast.total
                                                    .intensity_gCO2e_per_MJ,
                                            }
                                            : undefined,
                                    },
                                ]
                                : []).concat([
                                {
                                    name: "Intensity",
                                    color: theme_1.theme.colors.blackText,
                                    data: analysis.intensities.cumulative?.map((d) => ({
                                        date: new Date(d.date),
                                        value: d.intensity.adjusted_intensity_gCO2e_per_MJ,
                                    })) ?? [],
                                    prediction: forecastsAvailable && forecastDate
                                        ? {
                                            date: forecastDate,
                                            value: usageData.ship.forecast.total
                                                .adjusted_intensity_gCO2e_per_MJ,
                                        }
                                        : undefined,
                                },
                            ]), poiData: poiData, poiDataSetName: "Intensity", limits: [
                                {
                                    label: `${selectedYear} limit`,
                                    value: metadata.intensity[selectedYear],
                                    color: theme_1.theme.colors.red,
                                },
                            ] }) }), (0, jsx_runtime_1.jsx)(common_styled_components_1.GridCard, { children: (0, jsx_runtime_1.jsx)(LineChart_1.default, { title: "Carbon balance", unit: "tCO\u2082e to spare", data: (showNonAdjustedData && poiData.length
                                ? [
                                    {
                                        name: "Balance without transactions",
                                        color: theme_1.theme.colors.grey(2),
                                        data: analysis.intensities.cumulative?.map((d) => ({
                                            date: new Date(d.date),
                                            value: d.intensity.emission_balance_ton,
                                        })) ?? [],
                                        prediction: forecastsAvailable && forecastDate
                                            ? {
                                                date: forecastDate,
                                                value: usageData.ship.forecast.total
                                                    .emission_balance_ton,
                                            }
                                            : undefined,
                                    },
                                ]
                                : []).concat([
                                {
                                    name: "Carbon unit balance",
                                    color: theme_1.theme.colors.blackText,
                                    data: analysis.intensities.cumulative?.map((d) => ({
                                        date: new Date(d.date),
                                        value: d.intensity.adjusted_emission_balance_ton,
                                    })) ?? [],
                                    prediction: forecastsAvailable && forecastDate
                                        ? {
                                            date: forecastDate,
                                            value: usageData.ship.forecast.total
                                                .adjusted_emission_balance_ton,
                                        }
                                        : undefined,
                                },
                            ]), poiData: poiData, poiDataSetName: "Carbon unit balance" }) }), (0, jsx_runtime_1.jsx)(common_styled_components_1.GridCard, { children: (0, jsx_runtime_1.jsx)(LineChart_1.default, { title: "Cumulative emissions", unit: "tCO\u2082e", data: (showNonAdjustedData && poiData.length
                                ? [
                                    {
                                        name: "Emissions without transactions",
                                        color: theme_1.theme.colors.grey(2),
                                        dashed: false,
                                        data: analysis.intensities.cumulative?.map((d) => ({
                                            date: new Date(d.date),
                                            value: d.intensity.co2_emission_ton,
                                        })) ?? [],
                                        prediction: forecastsAvailable && forecastDate
                                            ? {
                                                date: forecastDate,
                                                value: usageData.ship.forecast.total.co2_emission_ton,
                                            }
                                            : undefined,
                                    },
                                ]
                                : []).concat([
                                {
                                    name: "Emissions",
                                    color: theme_1.theme.colors.blackText,
                                    dashed: false,
                                    data: analysis.intensities.cumulative?.map((d) => ({
                                        date: new Date(d.date),
                                        value: d.intensity.adjusted_co2_emission_ton,
                                    })) ?? [],
                                    prediction: forecastsAvailable && forecastDate
                                        ? {
                                            date: forecastDate,
                                            value: usageData.ship.forecast.total
                                                .adjusted_co2_emission_ton,
                                        }
                                        : undefined,
                                },
                                {
                                    name: "Emission limit",
                                    color: theme_1.theme.colors.red,
                                    dashed: true,
                                    data: analysis.intensities.cumulative?.map((d) => ({
                                        date: new Date(d.date),
                                        value: d.intensity.emission_limit_ton,
                                    })) ?? [],
                                    prediction: forecastsAvailable && forecastDate
                                        ? {
                                            date: forecastDate,
                                            value: usageData.ship.forecast.total.emission_limit_ton,
                                        }
                                        : undefined,
                                },
                            ]), poiData: poiData, poiDataSetName: "Emissions" }) }), analysis.fuel_spent.cumulative_fuel_timeline &&
                        (0, isNonEmptyObject_1.isNonEmptyObject)(analysis.fuel_spent.cumulative_fuel_timeline) && ((0, jsx_runtime_1.jsx)(common_styled_components_1.GridCard, { children: (0, jsx_runtime_1.jsx)(LineChart_1.default, { title: "Cumulative fuel use", unit: "t", data: Object.keys(analysis.fuel_spent.cumulative_fuel_timeline).map((fuelKey, i) => {
                                const fuelData = analysis.fuel_spent.cumulative_fuel_timeline[fuelKey];
                                return {
                                    name: metadata.fuels[fuelData.fuel]?.description ??
                                        "Name not found",
                                    color: (0, util_1.getFuelColor)(fuelData.fuel),
                                    data: fuelData.timeline.map((d) => ({
                                        date: new Date(d.date),
                                        value: d.amount,
                                    })),
                                    prediction: forecastFuels && forecastDate
                                        ? {
                                            date: forecastDate,
                                            value: forecastFuels[fuelKey],
                                        }
                                        : undefined,
                                };
                            }) }) }))] }), (0, jsx_runtime_1.jsx)(common_styled_components_1.ContentGrid, { "$cols": 1, children: (0, jsx_runtime_1.jsxs)(common_styled_components_1.GridCard, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.SmallTitle, { style: { marginBottom: theme_1.theme.spacing(2) }, children: "Compliance transactions" }), transactions?.from.length > 0 || transactions?.to.length > 0 ? ((0, jsx_runtime_1.jsx)(TransactionSummary_1.TransactionSummary, { transactions: transactions })) : ((0, jsx_runtime_1.jsx)(common_styled_components_1.P, { children: "No transactions" })), transactions?.from.length > 0 && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(common_styled_components_1.SmallSubtitle, { style: { marginBottom: theme_1.theme.spacing(2) }, children: ["Compliance transactions from ", shipData.name] }), (0, jsx_runtime_1.jsx)(TransactionTable_1.TransactionTable, { transactions: transactions.from, complianceYear: selectedYear, poolId: shipData.pool[selectedYear]?.pool_id, refresh: refreshAnalysis, isInAdminTools: false })] })), transactions?.to.length > 0 && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(common_styled_components_1.SmallSubtitle, { style: { marginBottom: theme_1.theme.spacing(2) }, children: ["Compliance transactions to ", shipData.name] }), (0, jsx_runtime_1.jsx)(TransactionTable_1.TransactionTable, { transactions: transactions.to, complianceYear: selectedYear, poolId: shipData.pool[selectedYear]?.pool_id, refresh: refreshAnalysis, isInAdminTools: false })] }))] }) }), (0, jsx_runtime_1.jsx)(common_styled_components_1.ContentGrid, { "$cols": 1, children: (0, jsx_runtime_1.jsxs)(common_styled_components_1.GridCard, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.SmallSubtitle, { style: { marginBottom: theme_1.theme.spacing(2) }, children: "Voyages" }), (0, jsx_runtime_1.jsx)(VoyageBarChart_1.default, { voyages: voyageData }), (0, jsx_runtime_1.jsx)(VoyageTable_1.VoyageTable, { voyages: voyageData, metadata: metadata, isInAdminTools: false })] }) })] }));
};
